import React, { useEffect, useState } from 'react';

const ToggleInput = ({
  value,
  setValue,
  name,
}: {
  value: boolean;
  name: string;
  setValue: (prev: any) => void;
}) => {
  const [enabled, setEnabled] = useState(value);
  useEffect(() => {
    setValue((prev: any) => {
      return {
        ...prev,
        [name]: enabled,
      };
    });
  }, [enabled]);

  return (
    <label className="w-11 h-auto py-2 flex items-center cursor-pointer relative">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={enabled}
        onChange={() => setEnabled(!enabled)}
      />
      <div className="w-full h-6 bg-gray-300 rounded-full peer-checked:bg-secondary transition-colors"></div>
      <div className="size-5 bg-white rounded-full shadow-md -ml-10 peer-checked:translate-x-4 transition-transform"></div>
    </label>
  );
};

export default ToggleInput;
